import { render, staticRenderFns } from "./task.vue?vue&type=template&id=623a8d8a&scoped=true"
import script from "./task.vue?vue&type=script&lang=ts"
export * from "./task.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623a8d8a",
  null
  
)

export default component.exports